import { render, staticRenderFns } from "./PageWrapper.vue?vue&type=template&id=14d107cd&scoped=true"
import script from "./PageWrapper.vue?vue&type=script&lang=js"
export * from "./PageWrapper.vue?vue&type=script&lang=js"
import style0 from "./PageWrapper.vue?vue&type=style&index=0&id=14d107cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d107cd",
  null
  
)

export default component.exports